export enum AddUserEvents {
  SAME_CENTRE_SAME_ROLE,
  SAME_CENTRE_NEW_ROLE,
  MULTIPLE_CENTRES_SAME_ROLE,
  MULTIPLE_CENTRES_NEW_ROLE,
}
